import FormattedMessage from 'I18n/components/FormattedMessage';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { ScreenReaderOnly } from 'foundations-components/transitional/components/ScreenReaderOnly';
import { MinusIcon } from 'foundations-assets/icons/components/MinusIcon';
import { SuccessIcon } from 'foundations-assets/icons/components/SuccessIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FeatureAvailableIcon = props => {
  return /*#__PURE__*/_jsxs("span", {
    "aria-live": "polite",
    "aria-atomic": true,
    children: [/*#__PURE__*/_jsx(IconCircle, Object.assign({
      icon: SuccessIcon,
      color: "fill-surface-default",
      backgroundColor: "icon-core-default",
      borderWidth: "0",
      size: "100"
    }, props)), /*#__PURE__*/_jsx(ScreenReaderOnly, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "compare.screenReader.featureAvailable"
      })
    })]
  });
};
export const FeatureUnavailableIcon = () => {
  return /*#__PURE__*/_jsxs("span", {
    "aria-live": "polite",
    "aria-atomic": true,
    children: [/*#__PURE__*/_jsx(IconHolder, {
      icon: MinusIcon,
      size: "100"
    }), /*#__PURE__*/_jsx(ScreenReaderOnly, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "compare.screenReader.featureUnavailable"
      })
    })]
  });
};